<template>
    <v-dialog
        v-if="getProjectActorDialog.visible"
        v-model="getProjectActorDialog.visible"
        no-click-animation
        persistent
        hide-overlay
        width="90%"
        max-width="920"
    >
        <v-card component="ProjectActorDialog">
            <v-card-title class="title">
                <div class="holder">{{ actor.meno_priezvisko }}</div>
                <btn class="close" :icon="'close'" size="icon" color="transparent" @click="close" />
            </v-card-title>
            <v-card-text class="body">
                <swiper-gallery :photos="actor.photos" :defaultImage="getDefaultImage" />
                <project-actor-dialog-body :actor="actor" />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Mp3Player from '@/components/.global/Mp3Player';
import ProjectActorDialogInfo from './ProjectActorDialogInfo';
import SwiperGallery from '@/components/.global/SwiperGallery';
import ProjectActorDialogBody from './ProjectActorDialogBody';

export default {
    name: 'ProjectActorDialog',

    components: { ProjectActorDialogBody, SwiperGallery, ProjectActorDialogInfo, Mp3Player },

    methods: {
        ...mapMutations(['setProjectActorDialog']),

        close() {
            this.setProjectActorDialog({ visible: false, actor: null });
        },
    },

    computed: {
        ...mapGetters(['getProjectActorDialog']),

        actor() {
            return this.getProjectActorDialog.actor;
        },

        getDefaultImage() {
            return this.actor.pohlavie == 'm' ? 'images/avatar.png' : 'images/avatarka.png';
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectActorDialog'] {
    overflow: hidden;
    .title {
        .flex-row;
        padding: 6px 8px 6px 20px !important;
        height: 45px;
        max-height: 45px;
        .font;
        cursor: move;

        .holder {
            margin-left: 505px;
            pointer-events: none;
        }
    }

    .body {
        display: flex;
        padding: 0 !important;
        background-color: #f2f2f2;
        color: black;

        [component='SwiperGallery'] {
            margin-top: -45px;
            border-radius: 10px 0 0 10px;
            overflow: hidden;
        }
    }

    //.data {
    //    margin-bottom: 20px;
    //    .flex-row;
    //    align-items: flex-start;
    //
    //    .cell {
    //        h3 {
    //            margin-top: 0;
    //        }
    //
    //        &.ratings {
    //            background-color: @white;
    //            padding: 10px;
    //            .radius;
    //        }
    //    }
    //
    //    .line {
    //        .flex-row;
    //        padding: 1px 0;
    //
    //        .name {
    //            margin-right: 7px;
    //        }
    //
    //        .value {
    //            font-weight: bold;
    //        }
    //    }
    //}

    //.portfolio {
    //    .scroll {
    //        min-height: 200px;
    //        height: 200px;
    //        overflow-y: auto;
    //    }
    //
    //    h3 {
    //        margin-bottom: 5px;
    //    }
    //
    //    .empty {
    //        font-size: 13px;
    //        color: fade(black, 50%);
    //    }
    //
    //    .item {
    //        .flex-row;
    //        justify-content: flex-start;
    //
    //        .name {
    //            margin-left: 10px;
    //            font-weight: bold;
    //            overflow: hidden;
    //
    //            .text {
    //                width: 100%;
    //                overflow: hidden;
    //                text-overflow: ellipsis;
    //                white-space: nowrap;
    //            }
    //        }
    //    }
    //}
}
</style>
